const INITIAL_STATE = {
    configurations: [],
    config: {},
    configUser: {},
    warehouses: [{ id: '01', text: 'Almoxaridado Físico' }],
    areas: [],
    areasShed: [],
    docks: [],
    sheds: [],
    shedsUnload: [],
    shedsLoad: [],
    rows: [{ id: '1', text: 'Fila 1' }],
    heights: [{ id: '1', text: 'Altura 1' }],
    types: [{ id: 'M', text: 'Matrícula' }, { id: 'R', text: 'Rack' }],
    hubs: [],
    resources: [],
    prints: [],
    resource: {},
    print: {},
    equipments: [],
    equipment: {},
    equipmentTypes: [],
    token: {},
    tokens: [],
    alertsEmailPaged: {},
    alertsEmail: [],
    alertEmail: {}
};

export default function configReducer(state, action) {

    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        // case 'SELECT_CONFIGURATION':
        //     return {
        //         ...state,
        //         config: state.config.find((c) => { return c.companyId === action.companyId && c.warehouseId === action.warehouseId; }),
        //     };
        case 'UPDATE_CONFIGURATION':
            return {
                ...state,
                config: action.config,
            };
        case 'RESET_CONFIGURATION':
            return {
                ...state,
                config: INITIAL_STATE.config,
            };
        case 'UPDATE_CONFIGURATIONS':
            return {
                ...state,
                configurations: action.configurations,
            };
        case 'UPDATE_WAREHOUSES':
            return {
                ...state,
                warehouses: action.warehouses,
            };
        case 'UPDATE_DOCKS':
            return {
                ...state,
                docks: action.docks,
            };
        case 'RESET_DOCKS':
            return {
                ...state,
                docks: INITIAL_STATE.docks,
            };
        case 'UPDATE_SHEDS':
            return {
                ...state,
                sheds: action.sheds,
                shedsLoad: action.sheds.filter((i) => i.modality === 'LOAD'),
                shedsUnload: action.sheds.filter((i) => i.modality === 'UNLOAD')
            };
        case 'RESET_SHEDS':
            return {
                ...state,
                sheds: INITIAL_STATE.sheds,
            };
        case 'LIST_PRINT': {
            return {
                ...state,
                prints: action.listPrints
            };
        }
        case 'SET_PRINT': {
            return {
                ...state,
                print: action.print
            };
        }
        case 'SET_CONFIG_USER': {
            return {
                ...state,
                configUser: action.configUser
            };
        }
        case 'LIST_RESOURCE': {
            return {
                ...state,
                resources: action.listResource
            };
        }
        case 'SET_RESOURCE': {
            return {
                ...state,
                resource: action.resource
            };
        }
        case 'LIST_EQUIPMENT': {
            return {
                ...state,
                equipments: action.listEquipments
            };
        }
        case 'SET_EQUIPMENT': {
            return {
                ...state,
                equipment: action.equipment
            };
        }
        case 'LIST_EQUIPMENT_TYPES': {
            return {
                ...state,
                equipmentTypes: action.equipmentTypes
            };
        }
        case 'LIST_TOKENS': {
            return {
                ...state,
                tokens: action.listTokens
            };
        }
        case 'SET_TOKEN': {
            return {
                ...state,
                token: action.token
            };
        }
        case 'SET_PRINT_FILTERS': {
            return {
                ...state,
                printFilters: action.printFilters
            };
        }
        case 'SET_RESOURCE_FILTERS': {
            return {
                ...state,
                resourceFilters: action.resourceFilters
            };
        }
        case 'SET_ALERT_EMAIL_PAGED': {
            return {
                ...state,
                alertsEmailPaged: action.alertsEmailPaged
            };
        }

        default:
            return state;
    }
}
